import { TARGET_SELECT_YEAR_TYPE } from './enums'

export const FRACTION_DIGITS_ONE_DIGITS = 1
export const TOTAL_EMISSION_FRACTION_DIGITS = 3
export const REGISTER_DATA_DIGITS = 12
export const PERCENTAGE_FRACTION_DIGITS = 1
export const INITIAL_PAGE = 1
export const ITEM_PER_PAGE = 10
export const DAIKOU_URL = 'https://daikou.tanso-man.com'
export const DENKICHECK_URL = 'https://denkicheck.jp/'
export const DEFAULT_FINANCIAL_MONTH = 4
export const YEAR_FINANCIAL_START = 2010
export const DEFAULT_TARGET_SELECT_YEAR = TARGET_SELECT_YEAR_TYPE.MONTH_YEAR
export const COLORS = {
  CHART_SCOPE_1: '#8BC34A',
  CHART_SCOPE_2: '#64B5F6',
  CHART_SCOPE_3: '#FFB74D',
}

export const CURRENT_YEAR_OPTION = {
  label: new Date().getFullYear().toString(),
  value: new Date().getFullYear().toString(),
}

export const CHART_COLOR_SCOPE = [
  '#93E3FF',
  '#F8CBAD',
  '#D0C4E5',
  '#FFE699',
  '#f08080',
  '#D0C4E5',
  '#4384F9',
  '#0616A7',
  '#D0C4E5',
  '#FFA07A',
  '#F4A460',
  '#C0C0C0',
  '#98FB98',
  '#87CEFA',
  '#B0C4DE',
  '#AFEEEE',
  '#F08080',
  '#D3D3D3',
  '#D2B48C',
  '#DEB887',
  '#E9967A',
  '#BC8F8F',
  '#F5DEB3',
  '#D8BFD8',
  '#BDB76B',
  '#C5B358',
  '#DAA520',
  '#8FBC8F',
  '#CD5C5C',
  '#4682B4',
  '#6A5ACD',
  '#708090',
  '#6495ED',
  '#66CDAA',
  '#A9A9A9',
  '#778899',
  '#8A2BE2',
  '#9ACD32',
  '#9370DB',
  '#BA55D3',
  '#C71585',
  '#D2691E',
  '#7B68EE',
  '#4682B4',
  '#4169E1',
  '#6B8E23',
  '#9932CC',
  '#8B4513',
  '#708090',
  '#556B2F',
]

export const CONVERT_TO_TCO2: Record<string, number> = {
  tCO2: 1,
  kgCO2: 1000,
  kgCO2e: 1000,
}

export const CATEGORY1 = {
  value: '529522aa-3968-48aa-a269-765035419cd7',
  label: '1. 購⼊した物品・サービス',
}

export const CLASSIFICATION_NAMES = {
  electric: '他社から供給された電気の使用',
}

export const CATEGORIES = [
  {
    value: '529522aa-3968-48aa-a269-765035419cd7',
    label: '1. 購⼊した物品・サービス',
  },
  {
    value: 'c467611c-994f-4ff0-8172-31c4483a58c2',
    label: '2. 資本財',
  },
  {
    value: 'eda76d60-4a78-4c93-a64e-e26c7580f9ef',
    label: '3. 燃料・エネルギー 関連',
  },
  {
    value: '5ca0455c-fab2-4924-8ce0-fd7d89009104',
    label: '4. 輸送、配送（上流）',
  },
  {
    value: '3bbae32e-afb6-494f-aa46-eff3074008e8',
    label: '5. 事業から出る廃棄物',
  },
  {
    value: '66268f3a-b0f5-44db-b747-3c8b88874c18',
    label: '6. 出張',
  },
  {
    value: 'fac1588c-a36f-4d58-9315-5b48946503f0',
    label: '7. 従業員の通勤',
  },
  {
    value: '01c4b6e6-b61a-41aa-b3e4-cd2262af48b3',
    label: '8. リース資産（上流）',
  },
  {
    value: '9ce8bcb1-4e7e-4305-99a5-aab396303b3a',
    label: '9. 輸送・配送（下流）',
  },
  {
    value: 'c67c3803-fbea-453c-9ae8-2a01095185b4',
    label: '10. 販売した製品の加⼯',
  },
  {
    value: 'b003644f-0864-445c-a297-c12b686020e0',
    label: '11. 販売した製品の使⽤',
  },
  {
    value: '74a4c157-8ee5-4816-8688-eddeb3ceb566',
    label: '12. 販売した製品の廃棄 ',
  },
  {
    value: '735b70a0-5c24-450c-ab29-14c666f9c2b0',
    label: '13. リース資産（下流）',
  },
  {
    value: '2b63374d-5e93-4146-ad4d-aa36cbac664d',
    label: '14. フランチャイズ',
  },
  {
    value: 'c6d56fe5-2aac-4c0c-88df-7031c866d2bd',
    label: '15. 投資',
  },
]
